// eslint-disable-next-line react/require-extension
import {
  IActivePurchase,
  IActivePurchaseCredits,
  IAddPaymentOption,
  IBankTransfer,
  IBPay,
  ICheque,
  ICompanyDetails,
  ICostItem,
  ICurrency,
  INonSubscriptionProduct,
  IPayID,
  IPayment,
  IProduct,
  IPurchaseCredit,
  IStoreCredits,
  IVerote,
} from 'redhotpie-shared-lib/interfaces/IPayment';
import { PAYMENT_GATEWAY, PRODUCT_GROUP, UPGRADE_PATH_TYPE } from '../constants/constants';
import * as utils from '../functions/utils';
import { calculateHighestCoinUnitPrice } from '../functions/utils';

class purchaseCredit {
  currency?: ICurrency;
  amount: number;
  expiryDate: string;
  purchaseDate: string;
  paymentProvider: string;
  productName: string;
  creditAmount: number;
  paymentMethodTitle: string;
  productGroup: string;

  constructor() {
    this.currency = undefined;
    this.amount = 0;
    this.expiryDate = '';
    this.purchaseDate = '';
    this.paymentProvider = '';
    this.productName = '';
    this.creditAmount = 0;
    this.paymentMethodTitle = '';
    this.productGroup = PRODUCT_GROUP.CONVERSATION_CREDITS;
  }

  static mappingPurchase(_obj: any): IPurchaseCredit {
    const obj = Object.assign(new purchaseCredit(), _obj);
    let objCurrency = undefined;
    if (_obj.Currency && _obj.Currency.hasOwnProperty('CurrencyID')) {
      objCurrency = currency.mappingObjects(_obj.Currency);
    }
    obj.currency = objCurrency;
    obj.amount = _obj.Amount || 0;
    obj.expiryDate = _obj.ExpiryDate || null;
    obj.purchaseDate = _obj.PurchaseDate || null;
    obj.paymentProvider = _obj.PaymentProvider || '';
    obj.paymentMethodTitle = _obj.PaymentProviderTitle;
    obj.productName = _obj.ProductName || '';
    obj.creditAmount = _obj.CreditAmount || 0;
    obj.productGroup = _obj.ProductGroup || PRODUCT_GROUP.CONVERSATION_CREDITS;

    return obj;
  }
}

class currency {
  currentId: number;
  name: string;
  symbol: string;
  code: string;
  dateCreated: string;

  constructor() {
    this.currentId = -1;
    this.name = '';
    this.symbol = '';
    this.code = '';
    this.dateCreated = '';
  }

  static mappingObjects(_obj: any): ICurrency {
    let obj = Object.assign(new currency(), _obj);
    obj.currentId = _obj.CurrencyID || -1;
    obj.name = _obj.Name || '';
    obj.symbol = _obj.Symbol || '';
    obj.code = _obj.Code || '';
    obj.dateCreated = _obj.DateCreated || '';
    obj = utils.cleanObjectKeys(Object.keys(new currency()), obj);

    return obj;
  }
}

// Model of Product
class costItem {
  id: number;
  text: string;
  durationType: string;
  price: number;
  siteCode: number;
  monthlyPrice: number;
  discount: number;
  token: string;
  bestValue: boolean;
  productID: string;
  productIDAndroid: string;

  constructor() {
    this.id = -1;
    this.text = '';
    this.durationType = '';
    this.price = -1;
    this.siteCode = -1;
    this.monthlyPrice = -1;
    this.discount = 0;
    this.token = '';
    this.bestValue = false;
    this.productID = '';
    this.productIDAndroid = '';
  }

  static mappingObjects(_obj: any): ICostItem {
    let obj = Object.assign(new costItem(), _obj);
    let discount = 0;
    switch (_obj.Cost.DiscountType) {
      case PAYMENT_GATEWAY.DISCOUNT.FIFTY_PERCENT:
        discount = 50;
        break;
      case PAYMENT_GATEWAY.DISCOUNT.TEN_PERCENT:
        discount = 10;
        break;
      case PAYMENT_GATEWAY.DISCOUNT.THIRTY_PERCENT:
        discount = 30;
        break;
      case PAYMENT_GATEWAY.DISCOUNT.TWENTY_FIVE_PERCENT:
        discount = 25;
        break;
      default:
        break;
    }
    let durationType = 'UpgradeMember.Month';
    if (_obj.Duration?.Length > 1) {
      durationType = 'UpgradeMember.Months';
    }
    obj.id = _obj.Duration?.Length || -1;
    obj.text = _obj.Duration?.Length || '';
    obj.durationType = durationType;
    obj.price = utils.formatNumberShowNDecimalPlaces(_obj.Cost.Price, 2) || -1;
    obj.siteCode = _obj.Cost.SiteCode || -1;
    obj.monthlyPrice = utils.formatNumberShowNDecimalPlaces(_obj.Cost.MonthlyPrice, 2) || -1;
    obj.discount = discount;
    obj.token = _obj.Token || '';
    obj.bestValue = _obj.Duration.Length === 6 && discount === 0;
    obj.productID = _obj.ProductID;
    obj.productIDAndroid = _obj.ProductIDAndroid;
    obj = utils.cleanObjectKeys(Object.keys(new costItem()), obj);

    return obj;
  }
}

// END
export class product {
  cost: ICostItem[];
  name: string;
  memberLevel: string;
  memberLevelValue: number;
  canBePurchased: boolean;

  constructor() {
    this.cost = [];
    this.name = '';
    this.memberLevel = '';
    this.memberLevelValue = -1;
    this.canBePurchased = false;
  }

  static mappingCost(items: any) {
    return items.map((itm: any) => costItem.mappingObjects(itm));
  }

  static mappingObjects(_obj: any): IProduct {
    let obj = Object.assign(new product(), _obj);
    obj.cost = (_obj.Cost && product.mappingCost(_obj.Cost)) || [];
    obj.name = _obj.Name || '';
    obj.memberLevel = _obj.MemberLevel || '';
    obj.memberLevelValue = _obj.MemberLevelValue || -1;
    obj.canBePurchased = _obj.CanBePurchased || false;
    obj = utils.cleanObjectKeys(Object.keys(new product()), obj);

    return obj;
  }
}

// Model Additional
class bPay {
  billerCode: number;
  reference: string;

  constructor() {
    this.billerCode = -1;
    this.reference = '';
  }

  static mappingObjects(_obj: any): IBPay {
    let obj = Object.assign(new bPay(), _obj);
    obj.billerCode = _obj.BillerCode || -1;
    obj.reference = _obj.Reference || '';
    obj = utils.cleanObjectKeys(Object.keys(new bPay()), obj);

    return obj;
  }
}

class bankTransfer {
  accountName: string;
  bsb: number;
  accountNumber: number;
  reference: number;

  constructor() {
    this.accountName = '';
    this.bsb = -1;
    this.accountNumber = -1;
    this.reference = -1;
  }

  static mappingObjects(_obj: any): IBankTransfer {
    let obj = Object.assign(new bankTransfer(), _obj);
    obj.accountName = _obj.AccountName || '';
    obj.bsb = _obj.BSB || -1;
    obj.accountNumber = _obj.AccountNumber || -1;
    obj.reference = _obj.Reference || -1;
    obj = utils.cleanObjectKeys(Object.keys(new bankTransfer()), obj);

    return obj;
  }
}

class cheque {
  accountName: string;
  address: string;
  reference: number;

  constructor() {
    this.accountName = '';
    this.address = '';
    this.reference = -1;
  }

  static mappingObjects(_obj: any): ICheque {
    let obj = Object.assign(new cheque(), _obj);
    obj.accountName = _obj.AccountName || '';
    obj.address = _obj.Address || '';
    obj.reference = _obj.Reference || -1;
    obj = utils.cleanObjectKeys(Object.keys(new cheque()), obj);

    return obj;
  }
}

class companyDetails {
  address: string;
  name: string;

  constructor() {
    this.address = '';
    this.name = '';
  }

  static mappingObject(_obj: any): ICompanyDetails {
    let obj = Object.assign(new companyDetails(), _obj);
    obj.address = _obj.Address || '';
    obj.name = _obj.Name || '';
    obj = utils.cleanObjectKeys(Object.keys(new companyDetails()), obj);

    return obj;
  }
}

class payID {
  number: number;
  ref: number;
  constructor() {
    this.number = -1;
    this.ref = -1;
  }

  static mappingObject(_obj: any): IPayID {
    let obj = Object.assign(new payID(), _obj);
    obj.number = _obj.Number || -1;
    obj.ref = _obj.Reference || -1;
    obj = utils.cleanObjectKeys(Object.keys(new payID()), obj);

    return obj;
  }
}

class verote {
  link: string;
  userName: string;
  constructor() {
    this.link = '';
    this.userName = '';
  }

  static mappingObjects(_obj: any): IVerote {
    let obj = Object.assign(new verote(), _obj);
    obj.link = _obj.Link || '';
    obj.userName = _obj.Username || '';
    obj = utils.cleanObjectKeys(Object.keys(new verote()), obj);

    return obj;
  }
}

class nonSubscriptionProduct {
  name: string;
  token: string;
  price: number;
  canBePurchased: boolean;
  type: string;
  constructor() {
    // this.cost = [];
    this.name = '';
    this.token = '';
    this.price = 0;
    this.canBePurchased = false;
    this.type = '';
  }

  static mappingObject(_obj: any): INonSubscriptionProduct {
    let obj = Object.assign(new nonSubscriptionProduct(), _obj);
    obj.name = _obj.Name || '';
    obj.token = _obj.Token || '';
    obj.canBePurchased = _obj.CanBePurchased || false;
    obj.price = _obj.Cost ? _obj.Cost.Price : 0;
    obj.type = _obj.Type || '';
    obj = utils.cleanObjectKeys(Object.keys(new nonSubscriptionProduct()), obj);

    return obj;
  }

  static mappingObjects(_arr: any): INonSubscriptionProduct[] {
    return _arr && _arr.length > 0 ? _arr.map((i: any) => nonSubscriptionProduct.mappingObject(i)) : [];
  }
}

class storeCredits extends nonSubscriptionProduct {
  value: string;
  type: string;
  icon: string;

  constructor() {
    super();
    this.value = '';
    this.type = '';
    this.icon = '';
  }

  static mappingStoreCredits(_obj: any): IStoreCredits {
    let obj: IStoreCredits = {
      ...storeCredits.mappingObject(_obj),
      value: 0,
      type: '',
      icon: '',
    };
    const arrName = obj.name.split(' ');
    if (arrName && arrName.length > 0) {
      obj.value = Number(arrName[0]) || 0;
      obj.type = arrName[1] || '';
    }
    obj.icon = _obj.PaymentIcon || '';
    obj = utils.cleanObjectKeys(Object.keys(new storeCredits()), obj);
    return obj;
  }

  static mappingObjects(arr: any): IStoreCredits[] {
    return arr && arr.length > 0 ? arr.map((i: any) => storeCredits.mappingStoreCredits(i)) : [];
  }
}

export default class payment {
  additionalPaymentOptions: IAddPaymentOption;
  currency?: ICurrency;
  isPaymentAvailable: boolean;
  paymentOptions: any[];
  productOptions: any[];
  products: IProduct[];
  nonSubscriptionProducts: INonSubscriptionProduct[];
  userDiscount: string;
  verotePaymentOptions?: IVerote;
  purchaseToken: string;
  upgradePath: string;
  isExistsCreditCard: boolean;
  updateToken: string;
  productToken: string;
  storeCredits: IStoreCredits[];
  highestCoinUnitPrice: number;
  constructor() {
    this.additionalPaymentOptions = {};
    this.currency = undefined;
    this.isPaymentAvailable = false;
    this.paymentOptions = [];
    this.productOptions = [];
    this.products = [];
    this.nonSubscriptionProducts = [];
    this.userDiscount = PAYMENT_GATEWAY.DISCOUNT.NO_DISCOUNT;
    this.verotePaymentOptions = undefined;
    this.purchaseToken = '';
    this.upgradePath = UPGRADE_PATH_TYPE.NONE;
    this.isExistsCreditCard = false;
    this.updateToken = '';
    this.productToken = '';
    this.storeCredits = [];
    this.highestCoinUnitPrice = 0;
  }

  static mappingProducts(items: any): IProduct[] {
    const res: IProduct[] = [];
    items.forEach((itm: any) => {
      res.push(product.mappingObjects(itm));
    });

    return res;
  }

  static mappingAdditional(item: any): IAddPaymentOption {
    let res = {};
    if (item.BPay) {
      res = { bPay: bPay.mappingObjects(item.BPay) };
    }
    if (item.BankTransfer) {
      res = {
        ...res,
        bankTransfer: bankTransfer.mappingObjects(item.BankTransfer),
      };
    }
    if (item.Cheque) {
      res = { ...res, cheque: cheque.mappingObjects(item.Cheque) };
    }
    if (item.CompanyDetails) {
      res = { ...res, companyDetails: companyDetails.mappingObject(item.CompanyDetails) };
    }
    if (item.PayID) {
      res = { ...res, payID: payID.mappingObject(item.PayID) };
    }

    return res;
  }

  static mappingObjects(_obj: any): IPayment {
    let obj = Object.assign(new payment(), _obj);
    obj.isPaymentAvailable = _obj.IsPaymentAvailable || false;
    obj.userDiscount = _obj.UserDiscount || PAYMENT_GATEWAY.DISCOUNT.NO_DISCOUNT;
    obj.currency = (_obj.Currency && currency.mappingObjects(_obj.Currency)) || {};
    obj.paymentOptions = _obj.PaymentOptions || [];
    obj.productOptions = _obj.ProductOptions || [];
    obj.products = (_obj.Products && payment.mappingProducts(_obj.Products)) || [];
    obj.additionalPaymentOptions = (_obj.AdditionalPaymentOptions && payment.mappingAdditional(_obj.AdditionalPaymentOptions)) || {};
    obj.verotePaymentOptions = (_obj.VerotelPaymentOptions && verote.mappingObjects(_obj.VerotelPaymentOptions)) || {};
    obj.purchaseToken = _obj.PurchaseToken || '';
    obj.upgradePath = _obj.UpgradePath || UPGRADE_PATH_TYPE.NONE;
    obj.isExistsCreditCard = _obj.IsStoredCardAvailable || false;
    obj.nonSubscriptionProducts = _obj.NonSubscriptionProducts ? nonSubscriptionProduct.mappingObjects(_obj.NonSubscriptionProducts) : [];
    obj.updateToken = _obj.PurchaseToken || '';
    obj.productToken = _obj.AddCreditCardProductToken || '';
    obj.storeCredits = _obj.StoreCredits ? storeCredits.mappingObjects(_obj.StoreCredits) : [];
    obj.highestCoinUnitPrice = calculateHighestCoinUnitPrice(_obj.StoreCredits || []);
    obj = utils.cleanObjectKeys(Object.keys(new payment()), obj);

    return obj;
  }

  static mappingActivePurchase(item: any): IActivePurchase | undefined {
    let o = undefined;
    if (item) {
      o = {
        memberLevel: item.MemberLevel,
        expiryDate: item.ExpiryDate,
        purchaseDate: item.PurchaseDate,
        paymentProvider: item.PaymentProvider,
        status: item.Status,
        paymentMethodTitle: item.PaymentProviderTitle,
      };
    }
    return o;
  }

  static mappingActivePurchaseArr(data: any): IPayment[] {
    if (data) {
      return data.map((item: any) => {
        return payment.mappingActivePurchase(item);
      });
    }
    return [];
  }

  static mappingActivePurchaseCredits(_object: any): IActivePurchaseCredits {
    const obj: IActivePurchaseCredits = {
      currentConversationCredits: 0,
      currentStoreCredits: 0,
      diamonds: 0,
      diamondsBalance: 0,
      conversationCredits: [],
      coinCredits: [],
    };
    const listConversationCredit: IPurchaseCredit[] = [];
    const listCoinCredit: IPurchaseCredit[] = [];
    if (_object && Array.isArray(_object.Purchases) && _object.Purchases.length > 0) {
      _object.Purchases.forEach((itm: any) => {
        const objPurchase = purchaseCredit.mappingPurchase(itm);
        if (objPurchase.productGroup === PRODUCT_GROUP.CONVERSATION_CREDITS) {
          listConversationCredit.push(objPurchase);
        } else if (objPurchase.productGroup === PRODUCT_GROUP.STORE_CREDITS) {
          listCoinCredit.push(objPurchase);
        }
      });
    }
    obj.currentConversationCredits = (_object && _object.CurrentConversationCredits) || 0;
    obj.currentStoreCredits = (_object && _object.CurrentStoreCredits) || 0;
    obj.diamonds = (_object && _object.Diamonds) || 0;
    obj.diamondsBalance = (_object && _object.DiamondsBalance) || 0;
    obj.conversationCredits = listConversationCredit;
    obj.coinCredits = listCoinCredit;

    return obj;
  }
}
